import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-caste-verification-grid',
  templateUrl: './caste-verification-grid.component.html',
  styleUrls: ['./caste-verification-grid.component.css']
})
export class CasteVerificationGridComponent implements OnInit {

  title = "Verification List";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/caste-verification/caste-verification-grid/caste-verification-grid.component.ts